module.exports = __webpack_public_path__ + "static/media/madfit-11.0fdf7693.jpg";